import { CsvHeaderModel } from '../../../models/CsvHeader';

export const MASTER_CATEGORY_CSV_HEADER: CsvHeaderModel[] = [
  {
    label: 'id',
    key: 'no_cat',
  },
  {
    label: 'masterCategoryNameEn',
    key: 'category_name_en',
  },
  {
    label: 'masterCategoryNameLa',
    key: 'category_name_la',
  },
 
  {
    label: 'masterDivisionName',
    key: 'masterDivisionName',
  },
  {
    label: 'description',
    key: 'description',
  },
  {
    label: 'code',
    key: 'code',
  },
];
